<template>
  <div class="bank-bind-page">
    <van-nav-bar
      title="绑定数字人民币"
      left-arrow
      @click-left="goBack"
    />

    <div class="header-card">
      <div class="header-title">绑定数字人民币</div>
      <div class="header-desc">请填写真实有效的数字人民币信息</div>
    </div>

    <div class="form-box">
      <div class="form-item">
        <div class="form-label">机构名称</div>

        <div v-if="form.type !== 'other'" class="form-value readonly">
          {{ form.bank_name }}
        </div>

        <input
          v-else
          v-model.trim="form.bank_name"
          class="form-input"
          type="text"
          maxlength="50"
          placeholder="请输入机构名称"
        />
      </div>

      <div class="form-item">
        <div class="form-label">姓名</div>
        <input
          v-model.trim="form.name"
          class="form-input"
          type="text"
          maxlength="30"
          placeholder="请输入持卡人姓名"
        />
      </div>

      <div class="form-item">
        <div class="form-label">账号</div>
        <input
          v-model.trim="form.account"
          class="form-input"
          type="text"
          maxlength="30"
          placeholder="请输入数字人民币账号"
        />
      </div>

      <van-button
        class="submit-btn"
        :loading="submitting"
        :disabled="submitting"
        @click="submit"
      >
        提交
      </van-button>
    </div>

    <div class="notice">
      <div class="notice-title">
        <span class="notice-icon">!</span>
        <span>温馨提示</span>
      </div>

      <div class="notice-text">
        请确认填写的数字人民币信息真实、准确。提交后将由平台进行审核，审核通过后即可用于大额拨付。
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name:"AssetBankBind",

  data(){
    return {
      submitting:false,
      checking:false,
      form:{
        type:"",
        bank_name:"",
        name:"",
        account:""
      }
    };
  },

  created(){
    const query=this.$route.query||{};

    this.form.type=query.type||"";

    if(this.form.type==="other"){
      this.form.bank_name="";
    }else{
      this.form.bank_name=query.name||"";
    }

    if(!this.form.type){
      this.$dialog.error("银行信息错误").then(()=>{
        this.goBack();
      });
    }
  },

  methods:{
    goBack(){
      this.$router.back();
    },

async checkLargePay(){
  try{
    const res=await request.get("/api/v1/user/largePayStatus");

    const result=res&&res.code!==undefined
      ?res
      :(res&&res.data?res.data:null);

    if(!result||result.code!==200){
      this.$dialog.error(
        result&&result.msg
          ?result.msg
          :"无法获取大额拨付状态"
      );
      return false;
    }

    const status=Number(
      result.data&&result.data.large_pay_status
    )||0;

    if(status!==1){
      this.$dialog.error("绑定数字人民币需开通大额拨付业务");
      return false;
    }

    return true;
  }catch(e){
    console.log("检查大额拨付状态失败",e);
    this.$dialog.error("验证失败，请稍后重试");
    return false;
  }
},

    async submit(){
      if(this.submitting){
        return;
      }

      if(this.form.type==="other"&&!this.form.bank_name){
        this.$dialog.error("请输入机构名称");
        return;
      }

      if(!this.form.name){
        this.$dialog.error("请输入姓名");
        return;
      }

      if(!this.form.account){
        this.$dialog.error("请输入数字人民币账号");
        return;
      }

      if(!/^\d+$/.test(this.form.account)){
        this.$dialog.error("数字人民币账号格式不正确");
        return;
      }

      const passed=await this.checkLargePay();

      if(!passed){
        return;
      }

      this.submitting=true;

      try{
        const res=await request.post(
          "/api/v1/user/assetBankBind",
          {
            bank_type:this.form.type,
            bank_name:this.form.bank_name,
            name:this.form.name,
            account:this.form.account
          }
        );

        const result=res&&res.code!==undefined
          ?res
          :(res&&res.data?res.data:null);

        if(!result||result.code!==200){
          this.$dialog.error(
            result&&result.msg
              ?result.msg
              :"提交失败，请稍后重试"
          );
          return;
        }

        this.$dialog.success(
          result.msg||"提交成功，请等待审核"
        ).then(()=>{
          this.$router.replace({
            path:"/asset"
          });
        });

      }catch(e){
        console.log("数字人民币提交失败",e);

        const result=e&&e.response&&e.response.data
          ?e.response.data
          :null;

        this.$dialog.error(
          result&&result.msg
            ?result.msg
            :"提交失败，请稍后重试"
        );
      }finally{
        this.submitting=false;
      }
    }
  }
};
</script>

<style scoped>
.bank-bind-page{
  min-height:100vh;
  background:#f7f8fa;
  box-sizing:border-box;
  padding-bottom:30px;
}

.header-card{
  margin:-1px 12px 0;
  padding:22px 20px 24px;
  border-radius:0 0 14px 14px;
  background:linear-gradient(135deg,#ff4b0b,#ff763b);
  color:#fff;
  box-shadow:0 5px 15px rgba(255,75,11,.12);
}

.header-title{
  font-size:21px;
  font-weight:700;
  margin-bottom:8px;
}

.header-desc{
  font-size:12px;
  opacity:.9;
}

.form-box{
  margin:18px 12px 0;
  padding:4px 16px 18px;
  background:#fff;
  border-radius:13px;
  box-shadow:0 3px 15px rgba(0,0,0,.04);
}

.form-item{
  min-height:58px;
  display:flex;
  align-items:center;
  border-bottom:1px solid #f1f1f1;
  box-sizing:border-box;
}

.form-item:last-of-type{
  border-bottom:0;
}

.form-label{
  width:80px;
  flex-shrink:0;
  color:#222;
  font-size:14px;
  font-weight:600;
}

.form-value{
  flex:1;
  min-width:0;
  font-size:14px;
  text-align:right;
}

.readonly{
  color:#333;
}

.form-input{
  flex:1;
  min-width:0;
  height:45px;
  padding:0 0 0 10px;
  border:0;
  outline:none;
  background:transparent;
  color:#333;
  font-size:14px;
  text-align:right;
  box-sizing:border-box;
}

.form-input::placeholder{
  color:#c5c5c5;
}

.submit-btn{
  width:100%;
  height:42px;
  margin-top:18px;
  border:0;
  border-radius:22px;
  background:#ff4b0b;
  color:#fff;
  font-size:14px;
  font-weight:600;
}

.notice{
  margin:14px 12px 0;
  padding:15px;
  background:#fff;
  border-radius:12px;
}

.notice-title{
  display:flex;
  align-items:center;
  color:#ff5a16;
  font-size:13px;
  font-weight:600;
  margin-bottom:7px;
}

.notice-icon{
  width:17px;
  height:17px;
  margin-right:7px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:#fff0e9;
  color:#ff5a16;
  font-size:11px;
}

.notice-text{
  color:#888;
  font-size:11px;
  line-height:1.7;
}
</style>
